import React, { useState } from "react";

import { Visible } from "../../core/components";
import { useEntitlements } from "../../contexts";
import ProductPrices from "../../product/components/ProductPrices";
import AiPricingView from "../../order/components/AiPricing/index";
import { Tabs } from "../../components/ui";

const INSIGHT_TABS = [
  { id: "pricing", label: "Pricing" },
  // Data validation screen (Feature 34, Lead Gen) — the AI-Extraction tab.
  { id: "ai-extraction", label: "AI-Extraction", feature: "data_validation_screen" },
];

const RCProductInsights = ({ user, product, requestType }) => {
  const [activeTab, setActiveTab] = useState("pricing");
  const { hasFeature } = useEntitlements();
  const tabs = INSIGHT_TABS.filter((tab) => !tab.feature || hasFeature(tab.feature));

  const canSeePricesInfo =
    user?.is_admin ||
    user?.can_see_market_prices ||
    user?.can_see_trade_prices;

  if (!canSeePricesInfo || !product) {
    return null;
  }

  return (
    <section className="rc-product-insights">
      <Tabs
        variant="underline"
        aria-label="Product insights"
        items={tabs.map((tab) => ({ value: tab.id, label: tab.label }))}
        value={activeTab}
        onChange={setActiveTab}
        data-btn="insights-toggle"
      />

      <div className="rc-product-insights__panel">
        <Visible when={activeTab === "pricing"}>
          <ProductPrices product={product} variant="embedded" />
        </Visible>
        <Visible when={activeTab === "ai-extraction" && hasFeature("data_validation_screen")}>
          <AiPricingView
            product={product}
            quoteType={requestType}
            isProductPreview
            variant="embedded"
          />
        </Visible>
      </div>
    </section>
  );
};

export default RCProductInsights;
